jQuery(function($) {
  
  	// Refresh Yotpo Widgets (for AJAX-injected recommended products)
    setTimeout(function() {
      var api = new Yotpo.API(yotpo);
      api.refreshWidgets();
    }, 1000);

    // Redirect 5/27/21
    if (window.location.host == 'mmeslds8ff1h74a3-41086681253.shopifypreview.com' &&
      window.location.href.indexOf('shop-20-off') > -1
    ) { 
      window.location = 'https://lasuiteskincare.com/collections/shop-20-off?utm_campaign=05.27.21%20-%2020%25%20OFF%20Sunscreen%20%28R44XMw%29&utm_medium=email&utm_source=All%20Subscribers';
    }
  
  
    // Easy Live Chat link
    $('a[href="#live-chat"]').click(function(e) {
      e.preventDefault();
      tidioChatApi.open();
    })
    
    // All Buttons on homepage are block-styled
    // $('body.template-index .font--block-link').each(function() {
    //   var $this = $(this);
    //   var $a = $this.children('a').first();
  
    //   $this.removeClass('font--block-link');
    //   $a.addClass('font--button font--button-outline');
    // });
    // $('#shopify-section-1519177213210 .font--button').addClass('white');
    
    // Product page customizations
    $('.row.social-share').insertAfter('#shopify-section-framework--product-recommendations');
    
    // Disable ReCharge on some variants
    $('body').on('change click', '.single-option-selector', function() {
  
      var variantID = $('#variant-listbox')[0].value;
      
      var variantsNotAllowedInASubscription = [
        '36210298486949', // Botanical Brightening Pads 2%
        '36210298519717'  // Botanical Brightening Pads 4%
      ];
      
      if (variantsNotAllowedInASubscription.indexOf(variantID) != -1) {
        $('.rc_radio__onetime').click();
        $('#rc_container').hide();
      } else {
        $('#rc_container').show();
      }
      
    });
    $(document).ready(function() {
      setTimeout(function() {
        $('.single-option-selector').trigger('change');
      }, 2000);
    });
    
    
    // Switch 'Out of Stock' notification on items not purchasable
    // without calling La Suite
    var $OOSNotification = $('.product-unavailable > p:first-of-type');
    var defaultOOSText = $OOSNotification.html();
    var callOOSText = 'This product requires a consultation to purchase. Please call us at <a style="text-decoration:underline" href="tel:2038617338">203-861-7338</a> for a consultation to review product protocol before purchasing 4% Hydroquinone.';
    $('body').on('change click', '.single-option-selector', function() {
      
      var variantID = $('#variant-listbox')[0].value;
      var variantsRequiringACall = [
        '36210298519717'  // Botanical Brightening Pads 4%
      ];
  
      setTimeout(function() {
        if (variantsRequiringACall.indexOf(variantID) != -1) {
          $OOSNotification.html(callOOSText);
          $('.product-unavailable > form').hide();
        } else {
          $OOSNotification.html(defaultOOSText);
          $('.product-unavailable > form').show();
        }
      }, 10);
      
    });
    
    
    // Product Accordion  
    var acc = document.getElementsByClassName("accordion-header");
    var content = document.getElementsByClassName('accordion-content');
  
    if (acc.length > 0) {
        acc[0].classList.add("active");
          content[0].classList.add("show");



        for (var i = 0; i < acc.length; i++) {
            acc[i].onclick = function() {
                var setClasses = !this.classList.contains('active');
                setClass(acc, 'active', 'remove');
                setClass(content, 'show', 'remove');

                if (setClasses) {
                    this.classList.toggle("active");
                    this.nextElementSibling.classList.toggle("show");
                }
            }
        }

        function setClass(els, className, fnName) {
            for (var i = 0; i < els.length; i++) {
                els[i].classList[fnName](className);
            }
        }

    };

          
    // Clear search query
    $('.search--clear').click(function(){
      $('input.search--textbox').val("");
    });
     
    // Clears query when modal is closed
    $('.search--close').click(function(){
      $('input.search--textbox').val("");
    });
 

    // Required Signature toggle 
    $('body').on('click', '.required-signature .required-insurance-input', function(){
      $('.required-signature .switch').toggleClass('checked');
    });


      /*
      $('.cart--root .add-to-cart-btn button').click(function() {
        var variantID = $(this).attr('data-variant-id');
        console.log('test we want to add variantID:', variantID);
        upsellAddToCart(variantID, 1);
      });
      */

      initCustomDuties();

      $(window).on('theme.cart.update-complete', initCustomDuties);
});

// Render Custom Duties
function loadCustomDutiesCountry(country) {
  if (country != 'US') {
    // Add fake checkout button to validate duties
    var dutiesButton = $('#duties-checkout-button');
    var checkoutButton = $('button[name="checkout"]');
    var dutiesError = $('#duties-error');
    if (!dutiesButton.length) {
      dutiesButton = $('<button/>').attr('id', 'duties-checkout-button').appendTo('.cart--checkout-button').html('Checkout');
      dutiesButton.on('click', function(e) {
        e.preventDefault();
        
        if (!dutiesError.length) {
          dutiesError = $('<div/>').attr('id', 'duties-error').addClass('error').insertAfter('.custom-duties-checkbox').html('You must agree that you are responsible for paying customs duties and taxes.');
        } else {
          dutiesError.show();
        }
      });
    }
    if ($('.custom-duties-checkbox-input').is(":checked")) {
      dutiesButton.hide();
      checkoutButton.show();
    } else {
      dutiesButton.show();
      checkoutButton.hide();
    }
    // $('.custom-duties-checkbox-input').prop('checked', true);
    //$('.custom-duties-checkbox .cd-switch').addClass('checked');
    $('.custom-duties-checkbox-input').on('change', function() {
      var checkbox = $(this);
      var label = checkbox.parents('.cd-switch').first();
      
      if (checkbox.is(':checked')) {
        label.addClass('checked');
        dutiesButton.hide();
        dutiesError.hide();
        checkoutButton.show();
      } else {
        label.removeClass('checked');
        dutiesButton.show();
        checkoutButton.hide();
      }
    });
  } else {
    $('.custom-duties-checkbox').hide();
  }
    console.log(country + "aaa");

}

function initCustomDuties() {
  if ($('.template-cart').length) {
    var country = sessionStorage.getItem("country");
    if (country === null) {
      jQuery.getJSON('/browsing_context_suggestions.json', function(info) {
          country = info.detected_values.country.handle;
          sessionStorage.setItem('country', country);
          loadCustomDutiesCountry(country);
        });
    } else {
      loadCustomDutiesCountry(country);
    }
  }
}
  	
// Add to cart for Cart Page
function upsellAddToCart(variant_id, qty) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: qty,
      id: variant_id
    },
    dataType: 'json',
    success: function (itemData) {
      console.log('success');
      window.location.href = '/cart'; // TODO: make mini-cart refresh rather than redirect to cart
    },
    error: function (XMLHttpRequest) {
      console.log(XMLHttpRequest.responseText);
    }
  });
}
function productItemAddtoCart(variant_id, qty) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: qty,
      id: variant_id
    },
    dataType: 'json',
    success: function (itemData) {
      theme.partials.Cart.updateAllHtml(function() {
        console.log(theme.partials.Cart.getHtml());
        $('.cart--root').attr('data-has-items', 'true');
        $('[data-off-canvas--open="right-sidebar"]').first().trigger('click');
      });
      console.log('success', itemData);

    },
    error: function (XMLHttpRequest) {
      console.log(XMLHttpRequest.responseText);
    }
  });
}
// Category Collection description
var textHolder = $(".plp-description");
var readMore = $('#more');

function toggleText() {
  textHolder.toggleClass("truncated");
  $(this).hide();
}

readMore.click(toggleText);
